import { AxiosResponse } from 'axios'
import { NuxtAxiosInstance } from '@nuxtjs/axios'
import BaseRepository from '../BaseRepository'

interface signupData {
  user: {
    email: string,
    phone: string,
    // eslint-disable-next-line camelcase
    first_name: string,
    // eslint-disable-next-line camelcase
    last_name: string,
    // eslint-disable-next-line camelcase
    user_agreement: boolean
  }
}

interface loginData {
  email: string,
  password: string,
}

interface setPasswordData {
  email: string,
  password: string,
  // eslint-disable-next-line camelcase
  password_confirmation: string,
}

interface resetPasswordData {
  // eslint-disable-next-line camelcase
  reset_password_token: string,
  password: string,
  // eslint-disable-next-line camelcase
  password_confirmation: string,
}

interface resetPasswordMailData {
  email: string
}

interface confirmationParams {
  // eslint-disable-next-line camelcase
  confirmation_token: string
}

interface resendConfirmationParams {
  email: string
}

export default class AuthRepository extends BaseRepository {
  constructor (protected endpoint: string, axios: NuxtAxiosInstance) {
    super(endpoint, axios)
  }

  public signup (data: signupData): Promise<AxiosResponse> {
    return this.$axios.post(`${this.endpoint}/sign_up`, data)
  }

  public login (data: loginData): Promise<AxiosResponse> {
    return this.$axios.post(`${this.endpoint}/log_in`, data)
  }

  public confirmation (params: confirmationParams): Promise<AxiosResponse> {
    return this.$axios.get(`${this.endpoint}/confirmation`, { params })
  }

  public resendConfirmation (params: resendConfirmationParams): Promise<AxiosResponse> {
    return this.$axios.get(`${this.endpoint}/resend_confirmation`, { params })
  }

  public setPassword (data: setPasswordData): Promise<AxiosResponse> {
    return this.$axios.post(`${this.endpoint}/set_password`, data)
  }

  public resetPasswordMail (data: resetPasswordMailData): Promise<AxiosResponse> {
    return this.$axios.post(`${this.endpoint}/password/reset`, data)
  }

  public resetPassword (data: resetPasswordData): Promise<AxiosResponse> {
    return this.$axios.post(`${this.endpoint}/password`, data)
  }

  public logout (): Promise<AxiosResponse> {
    return this.$axios.delete(`${this.endpoint}/log_out`)
  }
}
